import { Component } from '@angular/core';
import { MyharrellsService } from '../myharrells.service';

@Component({
  selector: 'app-matrix',
  standalone: true,
  imports: [],
  templateUrl: './matrix.component.html',
  styleUrl: './matrix.component.css'
})
export class MatrixComponent {

  myHarrellsLoginEmail: string;
  courseAlias: string


  constructor(public myHarrellsService: MyharrellsService) { }



  ngOnInit() {
    if (this.myHarrellsService.selectedCourse.isMatrixPublicCourse) {
      //the matrix course they are trying to access is public so use the generic login for matrix and let them see the course 
      this.LogUserIntoMatrixAsPublicUserAndGoToCourse();

    }
    else {
      //this is a private course so we need to log them into matrix and take them to the course
      this.LogUserIntoMatrixAndGoToCourse();
    }
  }

  LogUserIntoMatrixAndGoToCourse() {

    //this will be under myharrells login so we will use the logged in users email address and our 
    //one size fits all password to log them into matrix 
    //if they do not have an account in matrix this will create one for them and make them a user
    //if they aren't enrolled in this course it will enroll them in it 
    //then it will redirect them to the matrix home page
    let loggedInUser = JSON.parse(sessionStorage.getItem('loggedInMyHarrellsUser'));


    this.myHarrellsLoginEmail = loggedInUser.Email; //'accounting@canoaranchgolfclub.com'; //'allisahm@gmail.com'; //'mwisler@harrells.com';
    this.courseAlias = this.myHarrellsService.courseAliasSelected; // 'fusarium'; //'fairyringmanagement'

    this.myHarrellsService.ValidateUserInMatrixLMSSystemAsync(this.myHarrellsLoginEmail, this.courseAlias, this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin).subscribe((data: any) => {

      //should be in the matrix system now and enrolled in the course
      //take them to the matrix

      (document.getElementById("userid") as HTMLInputElement).value = loggedInUser.Email; //'accounting@canoaranchgolfclub.com';// 'allisahm@gmail.com'; // 'mwisler@harrells.com';
      (document.getElementById("password") as HTMLInputElement).value = '7!k8CoWf$3'; //this is a universal password for all users in the system
      (document.getElementById("submitButton") as HTMLButtonElement).click();


      // //open specific course in matrix
      // let url = 'https://harrells.matrixlms.com/user_catalog_class/show/' + this.myHarrellsService.courseIdToUse; //this is the url for the public course in matrix
      // //window.open('https://harrells.matrixlms.com/user_catalog_class/show/1381320','_blank'); //this is the url for the public course in matrix
      // window.open(url, '_blank');
    });

  }

  LogUserIntoMatrixAsPublicUserAndGoToCourse() {
    // uses the public matrix user to log them in and take them to the course

    this.courseAlias = this.myHarrellsService.courseAliasSelected; // 'fusarium'; //'fairyringmanagement'

    this.myHarrellsService.ValidateUserInMatrixLMSSystemAsync('harrellslearner@harrells.com', this.courseAlias, this.myHarrellsService.matrixCouseToViewAfterSuccessfulLogin).subscribe((data: any) => {

      //should be in the matrix system now and enrolled in the course
      //take them to the matrix

      (document.getElementById("userid") as HTMLInputElement).value = 'publiclearner';  // 'harrellslearner@harrells.com'; //this is used to passify the matrix system and email is our primary key  loggedInUser.Email; //'accounting@canoaranchgolfclub.com';// 'allisahm@gmail.com'; // 'mwisler@harrells.com';
      (document.getElementById("password") as HTMLInputElement).value = 'har0345!mh30'; //this is a password for the matrix user with public access only 
      (document.getElementById("submitButton") as HTMLButtonElement).click();

      // //open specific course in matrix
      // let url = 'https://harrells.matrixlms.com/user_catalog_class/show/' + this.myHarrellsService.courseIdToUse; //this is the url for the public course in matrix
      // //window.open('https://harrells.matrixlms.com/user_catalog_class/show/1381320','_blank'); //this is the url for the public course in matrix
      // window.open(url, '_blank');



    });


  }

}
